export default __webpack_public_path__ + "static/media/angbao-bonus.33fd5d7c.webp";